import { createFileRoute } from '@tanstack/react-router'
import { AboutPage } from '@/components/infoPages/AboutPage'
import { withPublicPageSeo } from '@/modules/seo'

const AboutPageWithSeo = withPublicPageSeo('about', AboutPage)

export const Route = createFileRoute('/$lang/about')({
  component: AboutPageWithSeo,
})
